import { PayloadAction } from '@reduxjs/toolkit';
import { apiGetCall, apiPostCall } from '../api';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
    fetchFormDataSuccess, fetchFormDataStart, fetchFormDataFailure,
    submitFormRequest, submitFormSuccess, submitFormFailure
} from '../slices/subSellerSignUpSlice';
import { setShowSuccessPopUp } from '../slices/sellerProfileSlice';
 
const URL = process.env.REACT_APP_API_BASE;
 
function* fetchFormDataSaga(action: PayloadAction<boolean>) {
    try {
        const businessModelResponse = yield call(apiGetCall, URL + 'sub-seller-business-type');
        const gdsResponse = yield call(apiGetCall, URL + 'seller-aggregator');
        yield put(fetchFormDataSuccess({ businessModelResponse, gdsResponse }));
    } catch (error: any) {
        yield put(fetchFormDataFailure(error.message));
    }
}
 
function* submitFormSaga(action: ReturnType<typeof submitFormRequest>) {
    const { errorMessage, ...formPayload } = action.payload;
    try {
        const response = yield call(apiPostCall, URL + 'sub-seller-registration', formPayload.formData);
        if (response.status === 'Successful') {
            yield put(submitFormSuccess());
        } else {
            yield put(submitFormFailure('Form submission failed'));            
            yield put(setShowSuccessPopUp({ message: 'Form submission failed', successType: 'error' }));
        }
    } catch (error: any) {
        yield put(submitFormFailure(error.message));        
        yield put(setShowSuccessPopUp({ message: errorMessage, successType: 'error' }));
    }
}
 
export default function* subSellerSignUpSaga() {
    yield takeLatest(fetchFormDataStart.type, fetchFormDataSaga);
    yield takeLatest(submitFormRequest.type, submitFormSaga);
}
 
 
 